<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100 start-project">
        <md-card class="">
          <form>
            <md-card-header class="md-card-header-icon">
              <div class="card-icon">
                <md-icon>group</md-icon>
              </div>
              <h4 class="title">
                Edit Company
              </h4>
            </md-card-header>
            <md-card-content class="content-inputs">
              <div class="md-layout start-inputs">
                <md-field class="md-layout-item md-size-100">
                  <label>Company Name</label>
                  <md-input v-model="company.company.company_name" required type="text"></md-input>
                </md-field>
                <AutoCompleteInput v-on:childToParent="onChildClick" v-bind:existingaddress="existingaddress" />
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Second Street Address</label>
                  <md-input v-model="company.company.address_attributes.address_line_2" type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company City</label>
                  <md-input v-model="company.company.address_attributes.city" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Locality/State/Province</label>
                  <md-input v-model="company.company.address_attributes.state" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Zip Code/Postal Code</label>
                  <md-input v-model="company.company.address_attributes.zip_code" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Office Phone</label>
                  <md-input v-model="company.company.office_phone" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Email</label>
                  <md-input v-model="company.company.company_email_address" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>GPR Task Type</label>
                  <md-select v-model="company.company.gpr_task_type">
                    <md-option value="imperial">Imperial</md-option>
                    <md-option value="metric">Metric</md-option>
                  </md-select>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Type</label>
                  <md-select v-model="company.company.company_type">
                    <md-option value="gpr_contractor">GPR Contractor</md-option>
                    <md-option value="facility">Facility</md-option>
                    <md-option value="contractor">Contractor</md-option>
                  </md-select>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100" v-if="company.files.length == 0">
                  <label class="upload-image">Upload a logo</label>
                  <md-file v-model="company.company.imgPlaceholder" @md-change="getFiles($event)" accept="image/*"
                    multiple required />
                  <div v-if="company.imgPreview">
                    <img :src="company.imgPreview" alt="Preview" />
                  </div>
                </md-field>
                <md-field class="md-layout-item md-size-100 md-medium-size-100">
                  <div class="files-display-item" v-if="company.files.length > 0">
                    <div class="fdi-wrap">
                      <img class="company_logo" :src="company.files[0].url" />
                    </div>
                    <md-button class="md-alert" v-on:click="deleteCompanyLogo(company.files[0].id)"
                      v-if="ifAdmin">Delete Company Logo</md-button>
                  </div>
                </md-field>
              </div>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <md-button class="md-success" v-on:click="showDialog">Invite Employee</md-button>
              <div>
                <md-button class="md-success" v-on:click="editCompany">Edit Company</md-button>
                <md-button class="md-alert" v-on:click="deleteCompany" v-if="ifAdmin">Delete Company</md-button>
              </div>
            </md-card-actions>
          </form>
        </md-card>
      </div>
      <!-- facility -->
      <md-card class="md-layout-item md-medium-size-100 md-size-100 edit-profile"
        v-if='company.company.company_type == "facility"'>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon"><md-icon>book</md-icon></div>
          <h4 class="title">Facilities</h4>
          <md-button class="md-success mt-4" v-on:click="showFacilityDialog">Add facility</md-button>
        </md-card-header>
        <md-card-content>
          <md-table v-model="facilities" table-header-color="green" class="employees">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Address">{{ item.address.street_address }} ; {{ item.address.city }},
                {{ item.address.state }} {{ item.address.zip_code }}</md-table-cell>
              <md-table-cell md-label="Members">
                <md-chip v-for="member in item.members" :key="member.id" class="md-primary">{{ member.name }}</md-chip>
              </md-table-cell>
              <md-table-cell md-label="" class="cell-icon"
                @click.native="deleteFacility(item)"><md-icon>delete_outline</md-icon></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      <!-- end facility -->

      <!-- users -->
      <md-card class="md-layout-item md-medium-size-100 md-size-100 edit-profile">
        <md-card-header class="md-card-header-icon">
          <div class="card-icon"><md-icon>group</md-icon></div>
          <h4 class="title">Employees</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="employees" table-header-color="green" class="employees">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
              <md-table-cell md-label="Phone">{{ item.phone_number }}</md-table-cell>
              <md-table-cell md-label="Level" class="cap">{{ item.level }}</md-table-cell>
              <md-table-cell md-label="GPR Access" class="cap">{{ item.gpr_access }}</md-table-cell>
              <md-table-cell md-label="GPR Task Type" class="cap">{{ item.gpr_task_type }}</md-table-cell>
              <md-table-cell md-label="Invite Sent" class="cap">{{ item.invited_at | formatDate }}</md-table-cell>
              <md-table-cell md-label="Invite Accepted?" class="cap">{{ item.invite_accepted }}</md-table-cell>
              <md-table-cell md-label="Edit" class="cell-icon" @click.native="handleEdit(item)"><md-icon
                  class="d-block">edit_outline</md-icon></md-table-cell>
              <md-table-cell md-label="" class="cell-icon"
                @click.native="deleteUser(item)"><md-icon>delete_outline</md-icon></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>

      <div class="dialog-wrapper">
        <md-dialog :md-active.sync="showUserInvite">
          <div class="title-top md-dialog-title">
            <h4>Invite a User</h4>
            <md-icon v-on:click.native="showDialog">close</md-icon>
          </div>
          <UserInviteAdmin v-on:closeBox="saveUser" :company_id="company.company.id" />
        </md-dialog>
      </div>

      <div class="dialog-wrapper">
        <md-dialog :md-active.sync="showFacility">
          <div class="title-top md-dialog-title">
            <h4>Add facility</h4>
            <md-icon v-on:click.native="showFacilityDialog">close</md-icon>
          </div>
          <AddFacility v-on:closeBox="saveFacility" :company="company.company.id" v-on:childToParent="addFacility" />
        </md-dialog>
      </div>

      <!--  -->
    </div>
  </div>
</template>
<script>
import UserInviteAdmin from "@/pages/Dashboard/Components/UserInviteAdmin.vue";
import AddFacility from "@/pages/Dashboard/Components/AddFacility.vue";
import api from '@/api';
import AutoCompleteInput from '@/pages/Dashboard/ProjectPages/Components/AutoCompleteInput.vue';
import idx from 'idx';

export default {
  components: {
    AutoCompleteInput,
    UserInviteAdmin,
    AddFacility
  },
  data() {
    return {
      showUserInvite: false,
      showFacility: false,
      company: {
        company: {
          address_attributes: {},
        }
      },
      existingaddress: '',
      employees: [],
      ifAdmin: this.$store.getters.isAdmin,
      facilities: [],
    }
  },
  created() {
    var companyId = this.$route.params.id;
    if (companyId == undefined) {
      this.$router.push("adminportal");
    } else {
      api.getCompanyDataAdmin(companyId).then((response) => {
        this.company = idx(response, _ => _.data);
        console.log('response.data.employees', response.data.employees)
        this.employees = response.data.employees;
        this.facilities = response.data.facilities;
        // this.isLoading = false;
        if (response.data.address !== null) {
          this.company.company.address_attributes = this.company.address;
          this.existingaddress = this.company.address.street_address;
        } else {
          this.company.company.address_attributes = { street_address: '', address_line_2: '', city: '', state: '', country: '', zip_code: '' }
        }
        console.log(this.company)

      });
    }
  },
  methods: {
    showDialog() {
      this.showUserInvite = !this.showUserInvite;
    },
    showFacilityDialog() {
      this.showFacility = !this.showFacility;
    },
    saveUser(newUser) {
      this.employees.push(newUser);
      this.showDialog();
    },
    editCompany() {
      api.updateCompanyData(this.company.company.id, this.company).then((response) => {
        this.notifyVue(`You have successfully edited ${this.company.company.company_name}.`);
        // this.$router.push("/adminportal");
      })
    },
    notifyVue(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "done_all",
        horizontalAlign: "left",
        verticalAlign: "top",
        type: "success"
      });
    },
    onChildClick(value) {
      this.company.company.address_attributes.street_address = value[0].long_name + ' ' + value[1].long_name;
      this.company.company.address_attributes.city = value[3].long_name;
      this.company.company.address_attributes.state = value[5].long_name;
      this.company.company.address_attributes.zip_code = value[7].long_name;
    },
    deleteUser(item) {
      if (confirm(`Are you sure you want to delete ${item.email}?`)) {
        var data = {
          user_id: item.id,
          company_id: this.company.company.id
        }
        api.deleteUserFromCompany(data).then((response) => {
          var index = this.employees.findIndex((u) => u.id == item.id);
          this.employees.splice(index, 1)
          this.notifyVue(`You have deleted ${item.email}`)
        })
      }
    },
    deleteCompany() {
      if (confirm(`Are you sure you want to delete this company?`)) {
        api.deleteCompany(this.company.company.id).then((response) => {
          this.notifyVue(`You have deleted this company`)
          this.$router.push(`/adminportal`)
        })
      }
    },
    deleteCompanyLogo(id) {
      if (confirm(`Are you sure you want to delete this company logo?`)) {
        api.deleteCompanyLogo(this.company.company.id, id).then((response) => {
          this.notifyVue(`You have deleted this company logo`)
          this.company.files = [];
          this.$router.push(`/editcompany/${this.company.company.id}`)
        })
      }
    },
    handleEdit(item) {
      this.$router.push(`/edituser/${item.id}`)
    },
    getFiles(filesList) {
      var formData = new FormData();
      const file = filesList[0]
      // filesList.forEach((file) => {
      var reader = new FileReader();

      // Define the onload event handler
      reader.onload = (event) => {
        // Set the preview image source to the loaded data URL
        console.log('load', event)
        this.company.imgPreview = event.target.result;
      };
      formData.append("file[]", file);
      api.addFileToCompany(this.company.company.id, formData).then(({ data }) => {
        this.company.files.push(data[0]);
        console.log('data', data)
        console.log('data', this.company.files)
        // this.$router.push(`/editcompany/${this.company.company.id}`)
      });
    },
    deleteFacility(item) {
      if (confirm(`Are you sure you want to delete ${item.name}?`)) {
        api.deleteFacility(item.id).then((response) => {
          var index = this.facilities.findIndex((u) => u.id == item.id);
          this.facilities.splice(index, 1)
          this.notifyVue(`You have deleted ${item.name}`)
        })
      }
    },
    addFacility(facility) {
      this.facilities.push(facility)
      console.log('added', facility);
    }
  },
};
</script>
<style lang="scss">
.extra-users {
  width: 100%;
}

.employee-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .md-layout-item {
    // display: inline-block;
  }
}
</style>
